import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowsRepeat: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrows-repeat, repost"><path d="M3.75 13.25V4.75H15.1071" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.6455 1.75L15.7527 4.75L12.6455 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.2502 10.75V19.25H8.89307" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.3542 22.25L8.24707 19.25L11.3542 16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowsRepeat;
